var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.334 17a1 1 0 1 1 0 2h-14a1 1 0 1 1 0-2zM21.334 13a1 1 0 1 1 0 2h-18a1 1 0 1 1 0-2zM17.334 9a1 1 0 1 1 0 2h-14a1 1 0 1 1 0-2zM21.334 5a1 1 0 1 1 0 2h-18a1 1 0 0 1 0-2z"
  })));
};
export default Svg24;